import { type BadgeProps } from '3-components/Badge/Badge';
import { type CategoryModel } from 'cms/cms-types';

export const resolveCategoriesToBadges = (data: (CategoryModel | null)[] | null | undefined, hasVideo?: boolean): BadgeProps[] | undefined => {
    if (hasVideo) {
        return [
            {
                label: 'Video',
                variant: 'subtle',
                prefixIcon: 'play',
            }
        ];
    }

    if (!data) {
        return undefined;
    }

    return data.map(item => {
        // the autogenerated produce | null for each item, need to remove the | null type
        const { Description } = item as NonNullable<typeof item>;

        return { label: Description || '' };
    });
};
